import { render, staticRenderFns } from "./PrivacyMiniApp.vue?vue&type=template&id=1d227dee"
import script from "./PrivacyMiniApp.vue?vue&type=script&lang=js"
export * from "./PrivacyMiniApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports